import { t } from 'ttag';

import { Modal } from '@ui/Modal';
import { Title } from '@ui/Title';
import { Button } from '@ui/Button';

import s from './RemoveProductFromSwapInfoModal.sss';

export interface ModalInfoData {
  title?: string | null,
  description?: string | null,
  removeButtonText?: string | null,
}

interface Props {
  isOpen: boolean,
  data?: ModalInfoData | null,
  onClose: () => void,
  onRemove: () => void,
}

export const RemoveProductFromSwapInfoModal: React.FC<Props> = ({
  isOpen,
  data,
  onClose,
  onRemove,
}) => (
  <Modal
    className={s.modal}
    isOpen={isOpen}
    withClose={false}
  >
    {!!data?.title && (
      <Title
        className={s.title}
        type='h3'
        bold={false}
      >
        {data?.title}
      </Title>
    )}

    {!!data?.description && (
      <p className={s.description}>
        {data.description}
      </p>
    )}

    <div className={s.actions}>
      {data?.removeButtonText ? (
        <>
          <Button
            className={s.button}
            theme='secondary'
            onClick={onClose}
          >
            {t`Назад`}
          </Button>

          <Button
            className={s.button}
            theme='swap'
            onClick={onRemove}
          >
            {data.removeButtonText}
          </Button>
        </>
      ) : (
        <Button
          className={s.button}
          onClick={onClose}
        >
          {t`Добре`}
        </Button>
      )}
    </div>
  </Modal>
);
